import * as React from 'react';
import { Route, useRouteMatch } from 'react-router';
import ExchangeManualActions from '../ManualActions/Exchange/Exchange';
var ExchangeRoutes = function (props) {
    var match = useRouteMatch();
    var baseUrl = match.url;
    return React.createElement(Route, { path: "".concat(baseUrl, "/manual"), exact: true, render: function () { return React.createElement(ExchangeManualActions, null); } });
};
export default ExchangeRoutes;
